import fetchWithAuth from "../utils/fetchWithAuth";
import { getEndpoints, buildEndpoint } from "../utils/ApiContext";

// TODO @gfonseca: Esta funcion no debería estar aca
export async function getFetchBaseUrl() {
  try {
    return await getEndpoints();
  } catch (err) {
    throw err;
  }
}

export const getUsers = async () => {
  await getEndpoints();
  const url = buildEndpoint("API_USERGET");
  const resp = await fetchWithAuth(url);

  if (!resp.ok) throw new Error("Error al obtener usuarios");
  return resp.json();
};

export const createUser = async userData => {
  await getEndpoints();
  const url  = buildEndpoint("API_REGISTER");
  const resp = await fetchWithAuth(url, {
    method: "POST",
    body  : JSON.stringify(userData),
  });

  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(`Error al crear usuario: ${resp.status} – ${txt}`);
  }
  return resp.json();
};

export const updateUserApi = async userData => {
  await getEndpoints();
  const url  = buildEndpoint("API_USERGET", userData.username);
  const body = {
    attributes: { email: userData.email || "" },
  };

  if (userData.groups) {
    body.groups = Array.isArray(userData.groups)
      ? Object.fromEntries(userData.groups.map(g => [g, true]))
      : userData.groups;
  }

  const resp = await fetchWithAuth(url, { method: "PUT", body: JSON.stringify(body) });
  if (!resp.ok) {
    const msg = await resp.text();
    throw new Error(`Error ${resp.status}: ${msg || resp.statusText}`);
  }
  try {
    return await resp.json();
  } catch {
    return { success: true };
  }
};

export const deleteUserApi = async username => {
  await getEndpoints();
  const url  = buildEndpoint("API_USERGET", username);
  const resp = await fetchWithAuth(url, { method: "DELETE" });

  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(`Error al eliminar usuario: ${resp.status} – ${txt}`);
  }
  return resp.json();
};

export const getProfiles = async () => {
  await getEndpoints();
  const url  = buildEndpoint("API_PROFILES");
  const resp = await fetchWithAuth(url);

  if (!resp.ok) throw new Error("Error al obtener perfiles");
  return resp.json();
};
export const getAdminProfiles = async (limit = 100, start_key = null) => {
  await getEndpoints();
  
  const params = new URLSearchParams();
  params.append('limit', limit.toString());
  
  if (start_key) {
    params.append('start_key', start_key);
  }
  
  const baseUrl = buildEndpoint("API_ADMIN_PROFILES");
  const url = baseUrl + `?${params.toString()}`;
  
  const resp = await fetchWithAuth(url);

  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(`Error al obtener perfiles de admin: ${resp.status} – ${txt}`);
  }
  
  const data = await resp.json();
  return data;
};

export const getProfileById = async (profileId) => {
  await getEndpoints();
  
  const url = buildEndpoint("API_ADMIN_PROFILES", profileId);
  
  const resp = await fetchWithAuth(url);

  if (!resp.ok) {
    if (resp.status === 404) return null;
    const txt = await resp.text();
    throw new Error(`Error al obtener perfil: ${resp.status} - ${txt}`);
  }
  
  const contentType = resp.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    return resp.json();
  } else {
    const text = await resp.text();
    try {
      return JSON.parse(text);
    } catch (e) {
      return { data: text };
    }
  }
};

export const getAssociations = async (filters = {}) => {
  await getEndpoints();
  
  const params = new URLSearchParams();
  
  if (filters.profile_id) params.append('profile_id', filters.profile_id);
  if (filters.limit) params.append('limit', filters.limit.toString());
  if (filters.start_key) params.append('start_key', filters.start_key);
  
  const baseUrl = buildEndpoint("API_ASSOCIATION_LIST");
  const url = baseUrl + (params.toString() ? `?${params.toString()}` : '');
  
  const resp = await fetchWithAuth(url);

  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(`Error al obtener asociaciones: ${resp.status} – ${txt}`);
  }
  
  const contentType = resp.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    return resp.json();
  } else {
    const text = await resp.text();
    try {
      return JSON.parse(text);
    } catch (e) {
      return { data: text };
    }
  }
};

export const getAssociationByUserId = async (userId) => {
  await getEndpoints();
  
  const url = buildEndpoint("API_ASSOCIATION_ITEM", userId);
  
  const resp = await fetchWithAuth(url);

  if (!resp.ok) {
    if (resp.status === 404) {
      return null;
    }
    const txt = await resp.text();
    throw new Error(`Error al obtener asociación: ${resp.status} - ${txt}`);
  }
  
  const contentType = resp.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    return resp.json();
  } else {
    const text = await resp.text();
    try {
      return JSON.parse(text);
    } catch (e) {
      return { data: text };
    }
  }
};

export const createAssociation = async data => {
  await getEndpoints();
  
  const url = buildEndpoint("API_ASSOCIATION_LIST");

  const resp = await fetchWithAuth(url, { 
    method: "POST", 
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data) 
  });

  if (!resp.ok) {
    const txt = await resp.text();
    if (resp.status === 409)
      throw new Error(`AlreadyAssociatedError: ${txt || resp.statusText}`);
    throw new Error(`Error al crear asociación (${resp.status}): ${txt || resp.statusText}`);
  }
  
  const contentType = resp.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    return resp.json();
  } else {
    const text = await resp.text();
    try {
      return JSON.parse(text);
    } catch (e) {
      return { data: text };
    }
  }
};

export const deleteAssociation = async userId => {
  await getEndpoints();
  
  const url = buildEndpoint("API_ASSOCIATION_ITEM", userId);
  
  const resp = await fetchWithAuth(url, { method: "DELETE" });

  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(`Error al eliminar asociación: ${resp.status} - ${txt}`);
  }
  return true;
};

export const verifyAssociation = userId => getAssociationByUserId(userId);

export const getGroups = async () => {
  await getEndpoints();
  const root = buildEndpoint("API_GROUPS");
  const resp = await fetchWithAuth(root);

  if (!resp.ok) throw new Error("Error al obtener grupos");
  const groups = await resp.json();

  // TODO @gfonseca: Backend right now is not returning users.
  const groupsWithUsers = await Promise.all(
    groups.map(async g => {
      try {
        const urlUsers  = buildEndpoint("API_GROUPS", g.groupname);
        const respUsers = await fetchWithAuth(urlUsers);
        const jsonUsers = respUsers.ok ? await respUsers.json() : {};
        return { ...g, users: jsonUsers.users || [] };
      } catch {
        return { ...g, users: [] };
      }
    }),
  );
  return groupsWithUsers
};

export const createGroup = async data => {
  await getEndpoints();
  const url  = buildEndpoint("API_GROUPS");
  const resp = await fetchWithAuth(url, { method: "POST", body: JSON.stringify(data) });

  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(`Error al crear grupo: ${resp.status} – ${txt}`);
  }
  return resp.json();
};

export const deleteGroup = async name => {
  await getEndpoints();
  const url  = buildEndpoint("API_GROUPS", name);
  const resp = await fetchWithAuth(url, { method: "DELETE" });

  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(`Error al eliminar grupo: ${resp.status} – ${txt}`);
  }
  return true;
};

export const updateGroup = async ({ groupname, description }) => {
  await getEndpoints();
  const url  = buildEndpoint("API_GROUPS", groupname);
  const resp = await fetchWithAuth(url, {
    method: "PUT",
    body: JSON.stringify({ description }),
  });

  const txt = await resp.text();
  if (!resp.ok) throw new Error(`Error al actualizar grupo (${resp.status}): ${txt || resp.statusText}`);
  try {
    return JSON.parse(txt);
  } catch {
    return { success: true };
  }
};